<template>
  <el-dialog
      top="10vh"
      width="70%"
      :title="title"
      append-to-body
      :close-on-click-modal="false"
      :visible.sync="visible"
      :before-close="handleCloseInit"
      >
    <el-form
      v-loading="loading"
      label-position="right"
      label-width="100px"
      :model="form"
      :rules="rules"
      ref="formRef">
      <el-form-item label="商品名称" prop="name">
        <el-input class="input-width-text" placeholder="请输入，限制30字" v-model="form.name" show-word-limit maxlength="30"></el-input>
      </el-form-item>
      <el-form-item label="短标题" prop="shortTitle">
        <el-input class="input-width-text" placeholder="请输入，限制30字" v-model="form.shortTitle" show-word-limit maxlength="30"></el-input>
      </el-form-item>
      <el-form-item label="商品头图" prop="topImageArr">
        <el-upload
          list-type="picture-card"
          :limit="1"
          :action="action"
          :headers="headers"
          :on-preview="handlePreview"
          :on-success="handleTopSuccess"
          :on-error="uploadError"
          :on-exceed="handleExceed"
          :on-remove="handleRemove"
          :file-list="form.topImageArr"
          :before-upload="beforeUpload">
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div>
          建议尺寸：800*800 像素，最多上传 1张。
        </div>
      </el-form-item>
      <el-form-item label="类目" prop="categoryId">
        <el-select v-model="form.categoryId" placeholder="请选择类目">
          <el-option
              v-for="item in categoryOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品描述" prop="remark">
        <el-input
          placeholder="请输入，限制500字"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 6}"
          v-model="form.remark"
          show-word-limit maxlength="500"/>
      </el-form-item>
      <el-form-item label="上架状态" prop="sku.status">
        <el-radio-group v-model="form.sku.status">
          <el-radio :label="1">上架</el-radio>
          <el-radio :label="0">下架</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="SKU名称" prop="sku.name">
        <el-input class="input-width-text" placeholder="请输入，限制30字" v-model="form.sku.name" show-word-limit maxlength="30"/>
      </el-form-item>
      <el-form-item label="SKU图" prop="sku.skuImageArr">
        <el-upload
            list-type="picture-card"
            :limit="1"
            :action="action"
            :headers="headers"
            :on-preview="handlePreview"
            :on-success="handleSkuSuccess"
            :on-error="uploadError"
            :on-exceed="handleExceed"
            :on-remove="handleSkuRemove"
            :file-list="form.sku.skuImageArr"
            :before-upload="beforeUpload">
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div>
          建议尺寸：800*800 像素，最多上传 1张。
        </div>
      </el-form-item>
      <el-form-item label="SKU原价" prop="sku.originPrice">
        <el-input class="input-width-number" placeholder="请输入SKU原价" v-model="form.sku.originPrice" show-word-limit>
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="SKU售价" prop="sku.salePrice">
        <el-input class="input-width-number" placeholder="请输入SKU售价" v-model="form.sku.salePrice" show-word-limit>
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="小程序路径" prop="path">
        <el-input placeholder="请输入" v-model="form.path"/>
      </el-form-item>

      <div class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </div>
    </el-form>

    <el-dialog
      title="预览"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%">
      <!--或者使用el-image组件-->
      <img :src="previewUrl"/>
    </el-dialog>
  </el-dialog>
</template>

<script>
import Xhs from "@/api/xhs";
const xhsApis = new Xhs();

const numberValidator = (rule, value, callback) => {
  const reg = /^(0|[1-9]\d*)(\.\d{1,2})?$/;
  if (value === '' || value === null || value === undefined) {
    callback(new Error('请输入值'));
  } else if (!reg.test(value)) {
    callback(new Error('请输入正数，最多保留两位小数'));
  } else {
    callback();
}}

export default {
  data(){
    return {
      visible: false,
      edit: true,
      loading: false,
      headers:{
        OPENTOKEN:localStorage.getItem('java-token')
      },
      action: process.env.VUE_APP_NEW_OPEN_URL  + '/movie/open/upload/merchant',
      form:{
        appId:'',
        name:'',
        topImageArr:[],
        shortTitle:'',
        categoryId:'65a612adc442c200016dc080',
        remark:'',
        path:'',
        sku:{
          skuImageArr:[],
          status: 1,
          name:'',
          originPrice:'',
          salePrice:'',
        }
      },
      detail:{},
      rules:{
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }],
        shortTitle: [
          { required: true, message: '请输入短标题', trigger: 'blur' }],
        topImageArr: [
          { required: true, message: '请上传商品头图', trigger: 'change' }],
        categoryId: [
          { required: true, message: '请选择类目', trigger: 'blur' }],
        remark: [
          { required: true, message: '请输入描述', trigger: 'blur' }],
        "sku.status": [
          { required: true, message: '请选择', trigger: 'blur' }],
        "sku.name": [
          { required: true, message: '请输入SKU名称', trigger: 'blur' }],
        "sku.skuImageArr": [
          { required: true, message: '请上传sku图', trigger: 'change'}],
        "sku.originPrice": [
          { required: true, message: '请输入SKU原价', trigger: 'blur' },
          {
            validator: numberValidator,
            trigger: 'blur'
          }],
        "sku.salePrice": [
          { required: true, message: '请输入SKU售价', trigger: 'blur' },
          {
            validator: numberValidator,
            trigger: 'blur'
          }],
        path: [
          { required: true, message: '请输入小程序路径', trigger: 'blur' }],
      },
      previewUrl: "",
      dialogVisible: false,
      categoryOptions:[
        {
          label:'影票团购',
          value:'65a612adc442c200016dc080'
        }
      ]
    }
  },
  computed:{
    title(){
      return this.edit ? '编辑商品' : '新建商品'
    }
  },
  methods:{
    handleSkuSuccess(res) {
      if(res.code === 200) {
        this.form.sku.skuImageArr = [{url:res.data}]
        this.$refs.formRef.clearValidate(['sku.skuImageArr'])
        this.$message.success('上传成功')
        return;
      }
      this.$message.error(res.message);
    },
    handleTopSuccess(res) {
      if(res.code === 200) {
        this.form.topImageArr = [{url:res.data}]
        this.$refs.formRef.clearValidate(['topImageArr'])
        this.$message.success('上传成功')
        return;
      }
      this.$message.error(res.message);
    },
    uploadError(err){
      this.$message.error(err);
    },
    handlePreview(file){
      this.dialogVisible = true;
      this.previewUrl = file.url;
    },
    handleRemove(){
      this.form.topImageArr = []
      this.$refs.formRef.validateField('topImageArr')
    },
    handleSkuRemove(){
      this.form.sku.skuImageArr = []
      this.$refs.formRef.validateField('sku.skuImageArr')
    },
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        const isImage = /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(file.name);
        const isLimit = file.size / 1024 / 1024 < 10;
        if (!isImage) {
          this.$message.error('只能上传图片!');
          return reject(false);
        }
        if (!isLimit) {
          this.$message.error('图片大小不能超过 10MB!');
          return reject(false);
        }
        resolve(true);
      });
    },
    handleExceed(_files, fileList){
      this.$message.error(`最多上传${fileList.length}张图`)
    },
    handleCancel(){
      this.visible = false
      this.handleCloseInit()
    },
    getAddParams(){
      const reqParams = { sku: {}}
      reqParams.appId = this.form.appId
      reqParams.name = this.form.name
      reqParams.shortTitle = this.form.shortTitle
      reqParams.topImage = this.form.topImageArr[0].url
      reqParams.categoryId = this.form.categoryId
      reqParams.remark = this.form.remark
      reqParams.path = this.form.path
      reqParams.sku.skuImage = this.form.sku.skuImageArr[0].url
      reqParams.sku.name = this.form.sku.name
      reqParams.sku.status = this.form.sku.status
      reqParams.sku.originPrice = (this.form.sku.originPrice * 100).toFixed(0)
      reqParams.sku.salePrice = (this.form.sku.salePrice * 100).toFixed(0)
      reqParams.sku.appId = this.form.sku.appId
      return reqParams;
    },
    getEditParams(){
      const reqParams = {
        ...this.detail,
      }
      reqParams.name = this.form.name
      reqParams.topImage = this.form.topImageArr[0].url
      reqParams.shortTitle = this.form.shortTitle
      reqParams.categoryId = this.form.categoryId
      reqParams.remark = this.form.remark
      reqParams.path = this.form.path
      reqParams.sku.skuImage = this.form.sku.skuImageArr[0].url
      reqParams.sku.name = this.form.sku.name
      reqParams.sku.status = this.form.sku.status
      reqParams.sku.originPrice = (this.form.sku.originPrice * 100).toFixed(0)
      reqParams.sku.salePrice = (this.form.sku.salePrice * 100).toFixed(0)
      return reqParams;
    },
    async handleConfirm(){
      await this.$refs.formRef.validate()
      // 进行保存
      this.loading = true
      const saveParams = this.edit ? this.getEditParams() : this.getAddParams()

      const { data } = await xhsApis.productAddOrEdit(saveParams).finally(()=>{
        this.loading = false
      })

      if(!data.success){
        this.$message.error(data.message);
        return;
      }

      this.$message.success('保存成功')
      this.$emit('refresh')
      this.visible = false
      this.handleCloseInit()
    },
    async handleEditInit(id){
      this.visible = true
      this.loading = true
      const { data } = await xhsApis.productDetail({
        id:id
      })

      if(!data.success){
        this.$message.error(data.message);
        return;
      }
      const mini = JSON.parse(localStorage.getItem("nowMini") || '');
      const detail = data.data
      this.$set(this, 'form', {
        appId: mini.miniAppId,
        name: detail.name,
        topImageArr: [],
        shortTitle: detail.shortTitle,
        categoryId: detail.categoryId,
        remark: detail.remark,
        path: detail.path,
        sku:{
          appId: mini.miniAppId,
          skuImageArr:[],
          status: detail.sku.status,
          name: detail.sku.name,
          originPrice: detail.sku.originPrice / 100,
          salePrice:detail.sku.salePrice / 100,
        }
      })
      this.$set(this, 'detail', detail)

      if(detail.topImage){
        this.form.topImageArr.push({
          url:detail.topImage
        })
      }

      if(detail.sku.skuImage){
        this.form.sku.skuImageArr.push({
          url: detail.sku.skuImage
        })
      }

      this.loading = false
    },
    handleAddInit(){
      this.visible = true
      const mini = JSON.parse(localStorage.getItem("nowMini") || '');
      this.form.appId = mini.miniAppId
      this.form.sku.appId = mini.miniAppId
    },
    handleCloseInit(){
      this.$set(this, 'form', {
        appId:'',
        name:'',
        topImageArr:[],
        shortTitle:'',
        categoryId:'65a612adc442c200016dc080',
        remark:'',
        path:'',
        sku:{
          appId:'',
          skuImageArr:[],
          status: 1,
          name:'',
          originPrice:'',
          salePrice:'',
        }
      })
      this.$refs.formRef.clearValidate()
      this.visible = false
    },
    open(id){
      this.edit = !!id
      // 编辑初始化
      if(this.edit){
        this.handleEditInit(id)
        return;
      }
      this.handleAddInit()
    }
  }
}

</script>

<style scoped lang="less">
.dialog-footer{
  margin-top: 40px;
  display: flex;
  justify-content: center;
}

.input-width-text{
  width: 500px;
}

.input-width-number{
  width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/xhsProductionCenter/editDialog.vue